import React from 'react'
import { Link } from 'gatsby'

const PrettyPath = (path) => {
  let pretty = path.path.replace(new RegExp('-', 'g'), ' ')

  return (
    <span className='capitalize' itemProp='name'>
      {pretty}
    </span>
  )
}

const Breadcrumb = (props) => {
  var splitUrl = props.location.pathname.split('/')
  splitUrl = splitUrl.filter(Boolean)
  var fullPath = ''
  var origin = props.location?.origin || process.env.GATSBY_COMPANY_URL?.replace(/\/$/, '')
  return (
    <>
      <nav className='mt-4 sm:hidden' aria-label='Back'>
        <a href='../' className='inline-block rounded border bg-white px-3 py-2 text-sm font-medium text-gray-500 hover:text-gray-700'>
          <div className='flex items-center'>
            <svg className='-mt-px -ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' aria-hidden='true' height='1.25em'>
              <path fillRule='evenodd' d='M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z' clipRule='evenodd' />
            </svg>
            Back
          </div>
        </a>
      </nav>
      <nav className='mt-4 hidden sm:flex' aria-label='Breadcrumb'>
        <ol className='flex items-center space-x-2' itemScope itemType='https://schema.org/BreadcrumbList'>
          <li className='inline-block' itemProp='itemListElement' itemScope itemType='https://schema.org/ListItem'>
            <div className='flex items-center'>
              <Link
                to='/'
                className='border-b border-blue-500 text-sm font-medium text-blue-500 hover:border-transparent hover:text-blue-600'
                itemScope
                itemType='https://schema.org/WebPage'
                itemProp='item'
                itemID={`${origin}${fullPath}`}>
                <span itemProp='name'>Home</span>
              </Link>
              <meta itemProp='position' content='1' />
            </div>
          </li>
          {splitUrl.map((path, index) => {
            fullPath = fullPath + '/' + path + '/'
            let position = index + 2
            return (
              <li key={`url-${index}`} className='inline-block' itemProp='itemListElement' itemScope itemType='https://schema.org/ListItem'>
                <div className='flex items-center'>
                  {splitUrl.length === index + 1 ? (
                    <>
                      <svg className='mt-px h-5 w-5 flex-shrink-0 text-gray-400' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' aria-hidden='true' height='1.25em'>
                        <path fillRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clipRule='evenodd' />
                      </svg>
                      <span aria-current='page' className='ml-2 text-sm font-medium text-gray-500'>
                        <PrettyPath path={path} />
                      </span>
                    </>
                  ) : (
                    <>
                      <svg className='mt-px h-5 w-5 flex-shrink-0 text-gray-400' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' aria-hidden='true' height='1.25em'>
                        <path fillRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clipRule='evenodd' />
                      </svg>
                      <Link
                        to={fullPath}
                        className='ml-2 border-b border-blue-500 text-sm font-medium text-blue-500 hover:border-transparent hover:text-blue-600 focus:outline-none focus:ring'
                        itemScope
                        itemType='https://schema.org/WebPage'
                        itemProp='item'
                        itemID={`${origin}${fullPath}`}>
                        <PrettyPath path={path} />
                      </Link>
                    </>
                  )}
                </div>
                <meta itemProp='position' content={position} />
              </li>
            )
          })}
        </ol>
      </nav>
    </>
  )
}

export default React.memo(Breadcrumb)
